import { render, staticRenderFns } from "./DownloadMax.vue?vue&type=template&id=52c1825c&scoped=true&"
import script from "./DownloadMax.vue?vue&type=script&lang=js&"
export * from "./DownloadMax.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMax.vue?vue&type=style&index=0&id=52c1825c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1825c",
  null
  
)

export default component.exports